export enum ShareReportModalHeaderAction {
  COPY_EMBEDED_CODE,
  EDIT_REPORT_BEFORE_SHARING,
}
